module.exports = __webpack_public_path__ + "img/30.d1817ba4.jpg";